import { DesignData } from 'editor/src/store/design/types';

// Cheap, stable string hash (djb2) over the analysis-relevant parts of the design
// so the host can remember dismissals per (product, design). Changes whenever an
// image is added/removed/replaced/moved/resized or a spread's technology changes.
function hashDesignForAnalysis(designData: DesignData | undefined): string {
  if (!designData?.spreads?.length) {
    return '';
  }

  const parts: string[] = [];
  designData.spreads.forEach((spread, spreadIndex) => {
    parts.push(`s${spreadIndex}:${spread.technology || ''}`);
    spread.pages?.[0]?.groups?.media?.forEach((element) => {
      if (element.type !== 'image' && element.type !== 'addon') {
        return;
      }
      const imageId = 'imageId' in element ? element.imageId : '';
      const url = 'url' in element ? element.url : '';
      parts.push(
        `${element.type}:${imageId || url || ''}:${Math.round(element.x)}:${Math.round(element.y)}:${Math.round(
          element.width,
        )}:${Math.round(element.height)}`,
      );
    });
  });

  const input = parts.join('|');
  // Polynomial rolling hash kept in a safe-integer range with modulo (no bitwise
  // ops, to satisfy the editor's no-bitwise lint rule).
  const MODULO = 2147483647; // 2^31 - 1
  let hash = 5381;
  for (let i = 0; i < input.length; i += 1) {
    hash = (hash * 33 + input.charCodeAt(i)) % MODULO;
  }
  return hash.toString(36);
}

export default hashDesignForAnalysis;
